import { asyncFetchDataPromiseActionFactory } from "../../../core/core-redux/actions/asyncFetchDataAction";
import { geoCalculationsService, GeoCalculationsServiceParams } from "./geoCalculations.service";
import GeoCalculationItem from "../../../geocalc/dto/GeoCalculationItem";

export const GEO_CALCULATIONS = "GEO_CALCULATIONS";

export const geoCalculationsActionCreator = asyncFetchDataPromiseActionFactory<
    GeoCalculationsServiceParams,
    GeoCalculationItem[],
    any
>(GEO_CALCULATIONS, geoCalculationsService);
